module.exports = __webpack_public_path__ + "assets/img/s2_tab2_active_m.d2fed6fc.png";